import { Global, css } from '@emotion/core';
import React from 'react';

const VITE_STATIC_URL = import.meta.env.VITE_STATIC_URL;
const FONTS_URL = `${VITE_STATIC_URL}/fonts`;

const sicboGlobalStyles = css`
    @font-face {
        font-family: 'ChowFun';
        font-display: swap;
        src: url(${FONTS_URL}/ChowFun.woff2) format('woff2'), 
            url(${FONTS_URL}/ChowFun.woff) format('woff'),
            url(${FONTS_URL}/ChowFun.ttf) format('truetype');
    }
    @font-face {
        font-family: 'BuiltTitlingRegular';
        font-display: swap;
        src: url(${FONTS_URL}/Built-Titling-Regular.woff2) format('woff2'),
            url(${FONTS_URL}/Built-Titling-Regular.woff) format('woff'),
            url(${FONTS_URL}/Built-Titling-Regular.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Aclonica';
        font-display: swap;
        src: url(${FONTS_URL}/Aclonica.woff2) format('woff2'),
            url(${FONTS_URL}/Aclonica.woff2) format('woff'),
            url(${FONTS_URL}/Aclonica.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Roboto Condensed';
        font-display: swap;
        font-weight: 400;
        src: url(${FONTS_URL}/RobotoCondensed-Regular.woff2) format('woff2'),
            url(${FONTS_URL}/RobotoCondensed-Regular.woff) format('woff'),
            url(${FONTS_URL}/RobotoCondensed-Regular.ttf) format('truetype');
    }
    @font-face {
        font-family: 'Roboto Condensed';
        font-display: swap;
        font-weight: 700;
        src: url(${FONTS_URL}/RobotoCondensed-Bold.woff2) format('woff2'),
            url(${FONTS_URL}/RobotoCondensed-Bold.woff) format('woff'),
            url(${FONTS_URL}/RobotoCondensed-Bold.ttf) format('truetype');
    }
    #dialog-container span {
        overflow: unset;
        max-width: unset;
    }
`;

const InjectGlobalSicbo = () => (
  <Global styles={sicboGlobalStyles} />
);

export default InjectGlobalSicbo;
